import React from 'react';
import Autosuggest from 'react-autosuggest';

class AutoComplete extends React.Component {

    constructor( props ) {

        super( props );

        this.state = {
            suggestions: []
        };

        this.getSuggestionValue          = this.getSuggestionValue.bind( this );
        this.onChange                    = this.onChange.bind( this );
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind( this );
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind( this );
        this.renderSuggestion            = this.renderSuggestion.bind( this );

    }

    getSuggestionValue( e ) {

        return e;

    }

    onChange( e ) {

        if ( ! ( 'name'  in e.target ) ) e.target.name  = this.props.name;
        if ( ! ( 'value' in e.target ) ) e.target.value = e.target.innerText;

        this.props.onChange( e );

    }

    onSuggestionsClearRequested() {

        this.setState( { suggestions: [] } );

    }

    onSuggestionsFetchRequested( { value } ) {

              value       = value.trim().toLowerCase();
        const suggestions = this.props.readonly || ! this.props.suggestions ? [] : this.props.suggestions.filter( e => e.label.toLowerCase().indexOf( value ) !== -1 );

        this.setState( { suggestions } );

    }

    renderSuggestion( e ) {

        return (

            <div>{e.label}</div>

        );

    }

    render() {

        const inputProps = {
            className:   this.props.className,
            name:        this.props.name,
            onChange:    this.onChange,
            placeholder: this.props.placeholder,
            readOnly:    this.props.readonly,
            value:       this.props.value || ''
        };

        return (

            <div className="auto-complete">

                <Autosuggest
                    suggestions={this.state.suggestions}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    id={this.props.id}
                />

            </div>

        );

    }

}

export default AutoComplete;